import { createSlice } from "@reduxjs/toolkit";
import { ILienholder } from "../../../../models/user/Lienholder/Lienholder";
import { GetAddLienholderFormJson } from "./LienholderActions";

const initialState: ILienholder = {
  addLienholderFormFieldsJson: null,
};

const lienholderSlice = createSlice({
  name: "lienholder",
  initialState: initialState,
  reducers: {
    setAddLienholderFormFieldsJson: (state, { payload }) => {
      state.addLienholderFormFieldsJson = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      GetAddLienholderFormJson.fulfilled,
      (state, { payload }) => {
        state.addLienholderFormFieldsJson =
          payload.status === "SUCCESS" ? payload.data : null;
      }
    );
  },
});

export default lienholderSlice.reducer;
export const { setAddLienholderFormFieldsJson } = lienholderSlice.actions;
